import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { filesForRegister } from "routes/asset-register/plugins/excel-import/controller/files-for-register"
import { Box, Container } from "@mui/material"
import { AssetFileImporterButton } from "./asset-file-importer-button"
import { PagedTable } from "lib/@components/paging/paged-table"
import { AssetRegisterRowMiddle, PagingSearchBarLeft } from "slot-definitions"
import { ImportedFilesTableRow } from "./imported-files-table-row"
import { assetRegisterTableStyles } from "lib/@components/paging/paged-table/two-tone/asset-register-table-styles"
import { AssetRegisterRowMiddleCell } from "lib/@components/paging/paged-table/two-tone/asset-register-table-cells"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { Secure } from "lib/authorization/secure"
import { hasDemand } from "lib/authorization/has-demand"

export function FileContentTab() {
    const assetImportedFilesHeaders = [
        { id: "importedFrom", label: "Name", align: "left" },
        { id: "numberOfAssets", label: "Asset Count", align: "left" },
        { id: "fileSize", label: "Size", align: "left" },
        { id: "importDate", label: "Uploaded", align: "left" },
        { id: "importedBy", label: "By", align: "left" },
        ...(hasDemand("manageAssetRegister") ? [{ id: "Remove", label: "", align: "left", canOrderBy: false }] : []),
    ]
    const { register } = useBoundContext()

    AssetRegisterRowMiddle.usePlug(<AddSizeColumn />)
    AssetRegisterRowMiddle.usePlug(<AddDateColumn />)

    return (
        <Container sx={{ mt: 3 }} maxWidth="xl">
            <PagingSearchBarLeft.Plug>
                <Secure hide demand="manageAssetRegister">
                    <Box>
                        <AssetFileImporterButton title="Import File" />
                    </Box>
                </Secure>
            </PagingSearchBarLeft.Plug>
            <PagedTable
                headers={assetImportedFilesHeaders}
                query={filesForRegister}
                queryParams={{ registerId: register?.id || null }}
                RowComponent={ImportedFilesTableRow}
                searchPlaceHolder={"Search Files"}
                top={true}
                tableSx={assetRegisterTableStyles}
                headerStyles={{ whiteSpace: "nowrap" }}
            />
        </Container>
    )
}

function AddDateColumn({ row }) {
    return (
        <AssetRegisterRowMiddleCell key={row.workbookIdentifier}>
            {new Date(row.importDate).format(DATE_FORMATS.medium)}
        </AssetRegisterRowMiddleCell>
    )
}

function AddSizeColumn({ row }) {
    return (
        <AssetRegisterRowMiddleCell key={row.workbookIdentifier}>
            {row.fileSize ? formatFileSize(row.fileSize) : "Unkown"}
        </AssetRegisterRowMiddleCell>
    )

    function formatFileSize(bytes) {
        if (bytes / 1024 < 1000) return `${(bytes / 1024).toFixed(1)}KB`
        else return `${(bytes / 1024 / 1024).toFixed(1)}MB`
    }
}
